'use strict';

const index = require('../node_modules/color-string/index.js');



module.exports = index.__moduleExports;
